var map = {
	"./21Bet_logo.png": "f953",
	"./avatar-gray.svg": "76d8",
	"./avatar.svg": "a692",
	"./google-logo.svg": "62de",
	"./icons/bulb.png": "418e",
	"./icons/check.png": "1ecc",
	"./icons/tooBad.svg": "e42c",
	"./icons/trophy.png": "8a14",
	"./landing/carrousel_bg.png": "09c8",
	"./landing/header.jpg": "41d8",
	"./landing/iphone.png": "2831",
	"./landing/mobile.jpg": "1862",
	"./landing/next.svg": "11bd",
	"./landing/pick8_logo.png": "a650",
	"./landing/pick_players.png": "7f31",
	"./landing/prev.svg": "184e",
	"./landing/slider_bg.png": "de17",
	"./landing/startWinning_CTA.png": "7505",
	"./landing/step_1.png": "9fb9",
	"./landing/step_2.png": "a106",
	"./landing/step_3.png": "928b",
	"./landing/thumb_Camara.png": "07c1",
	"./landing/thumb_Laptop.png": "29c7",
	"./landing/thumb_PlayStation4.png": "64f9",
	"./landing/thumb_tv.png": "82bf",
	"./landingSummer/bg-stripes.jpg": "9b34",
	"./landingSummer/bg1.jpg": "06e3",
	"./landingSummer/header-players.png": "bfdf",
	"./landingSummer/logo-pick8.svg": "a2ff",
	"./landingSummer/paid.svg": "e516",
	"./landingSummer/players.png": "9576",
	"./landingSummer/prize.svg": "ffee",
	"./landingSummer/prizes.png": "6fcd",
	"./landingSummer/rating.png": "9028",
	"./landingSummer/screen_cn.jpg": "13b8",
	"./landingSummer/screen_en.jpg": "f079",
	"./landingSummer/screen_th.jpg": "53f1",
	"./landingSummer/screen_tr.jpg": "eb13",
	"./landing_tr/get-ready-bg-left.png": "f6f2",
	"./landing_tr/get-ready-bg-right.png": "930b",
	"./landing_tr/header.jpg": "e314",
	"./landing_tr/mobile.png": "e339",
	"./landing_tr/pattern.jpg": "f871",
	"./logo-black-cn.svg": "6ef9",
	"./logo-black-en.svg": "5b14",
	"./logo-black-th.svg": "ecb9",
	"./logo-black-tr.svg": "12c9",
	"./logo-pick8.png": "e8f5",
	"./logo-skor.png": "8c7b",
	"./logo-white-cn.svg": "7543",
	"./logo-white-en.svg": "45d8",
	"./logo-white-th.svg": "61f1",
	"./logo-white-tr.svg": "1f61",
	"./modal_bg.jpg": "465d",
	"./modal_bg_red.jpg": "3f4c",
	"./newLanding/iphone.png": "a14e",
	"./newLanding/logo_CSL.png": "d520",
	"./newLanding/logo_EPL.png": "c609",
	"./newLanding/logo_NBA.png": "acac",
	"./newLanding/slider_products.jpg": "910b",
	"./newLanding/slider_products_mobile.jpg": "4ac9",
	"./newLanding/star.png": "4f1e",
	"./newLanding/white_bg.png": "b683",
	"./pick8_Prizes_Phone.jpg": "ca9c",
	"./pick8_Prizes_Stadium.jpg": "0399",
	"./player.svg": "5e64",
	"./playerBack.svg": "4d24",
	"./playground.svg": "2913",
	"./skor_logo_en.svg": "cccf",
	"./skor_logo_tr.svg": "e275",
	"./spinner.svg": "6e43",
	"./spinner_white.svg": "c113",
	"./sport_balls.svg": "17db",
	"./welcomeModal/P8_popup_thumb_1.5.png": "ef0e",
	"./welcomeModal/P8_popup_thumb_1_cn.png": "3fa6",
	"./welcomeModal/P8_popup_thumb_1_en.png": "d882",
	"./welcomeModal/P8_popup_thumb_1_th.png": "46ab",
	"./welcomeModal/P8_popup_thumb_1_tr.png": "be3f",
	"./welcomeModal/P8_popup_thumb_2_cn.png": "7bb7",
	"./welcomeModal/P8_popup_thumb_2_en.png": "6c6d",
	"./welcomeModal/P8_popup_thumb_2_th.png": "9c71",
	"./welcomeModal/P8_popup_thumb_2_tr.png": "6071",
	"./welcomeModal/P8_popup_thumb_3_cn.png": "34d5",
	"./welcomeModal/P8_popup_thumb_3_en.png": "352a",
	"./welcomeModal/P8_popup_thumb_3_th.png": "63d4",
	"./welcomeModal/P8_popup_thumb_3_tr.png": "dbed",
	"./welcomeModal/P8_popup_thumb_4_cn.png": "a9f0",
	"./welcomeModal/P8_popup_thumb_4_en.png": "1632",
	"./welcomeModal/P8_popup_thumb_4_th.png": "0135",
	"./welcomeModal/P8_popup_thumb_4_tr.png": "2e8e",
	"./welcomeModal/P8_popup_thumb_5_cn.png": "17e0",
	"./welcomeModal/P8_popup_thumb_5_en.png": "52e0",
	"./welcomeModal/P8_popup_thumb_5_th.png": "1424",
	"./welcomeModal/P8_popup_thumb_5_tr.png": "b01a",
	"./welcomeModal/P8_popup_thumb_6_cn.png": "0859",
	"./welcomeModal/P8_popup_thumb_6_en.png": "919d",
	"./welcomeModal/P8_popup_thumb_6_th.png": "72e5",
	"./welcomeModal/P8_popup_thumb_6_tr.png": "d1a6",
	"./welcomeModal/skor-step-2.png": "cc33",
	"./welcomeModal/skor-step-3.png": "3f6b",
	"./welcomeModal/skor-step-4.png": "5811",
	"./welcomeModal/skor-step-5.png": "5cac",
	"./wheel/ball.png": "354b",
	"./wheel/bottom-text-en.png": "bcb1",
	"./wheel/bottom-text-en.webp": "a63c",
	"./wheel/bottom-text-th.png": "2ba4",
	"./wheel/bottom-text-th.webp": "41d4",
	"./wheel/button-spin-en.png": "a360",
	"./wheel/button-spin-en.webp": "1990",
	"./wheel/button-spin-th.png": "f765",
	"./wheel/button-spin-th.webp": "d34c",
	"./wheel/coins.png": "05be",
	"./wheel/ribbons.png": "503c",
	"./wheel/title-en.png": "f54a",
	"./wheel/title-en.webp": "34f9",
	"./wheel/title-th.png": "fad1",
	"./wheel/title-th.webp": "dd3b",
	"./wheel/wheel-of-fotrune-bg-sm.jpg": "c5ae",
	"./wheel/wheel-of-fotrune-bg.jpg": "4b25",
	"./wheel/wheel-win-background.png": "40c6",
	"./wheel/wheel.png": "787c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";